import { useQuery } from '@tanstack/react-query';

import { listAudit, type AuditFilters } from '../api/audit';

export function useAuditLog(filters: AuditFilters) {
  return useQuery({
    queryKey: ['audit', filters],
    queryFn: () => listAudit(filters),
    refetchOnWindowFocus: false,
  });
}
